(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[794],{

/***/ 8433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));

var _jsxRuntime = __webpack_require__(5893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"
}), 'EastOutlined');

exports.Z = _default;

/***/ }),

/***/ 1047:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournament/[...slug]",
      function () {
        return __webpack_require__(4447);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _YouTubePlaylist__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _YouTubePlaylist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3602);



/***/ }),

/***/ 4447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ TournamentOverviewPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(1526);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(3299);
// EXTERNAL MODULE: ./components/TournamentPageTabs/TournamentPageTabs.tsx
var TournamentPageTabs = __webpack_require__(4556);
// EXTERNAL MODULE: ./context/UIContext.tsx
var UIContext = __webpack_require__(6849);
// EXTERNAL MODULE: ./components/TournamentPageTabs/translationKeys.json
var translationKeys = __webpack_require__(7046);
// EXTERNAL MODULE: ./components/TournamentPageTabs/TournamentPageTabs.module.css
var TournamentPageTabs_module = __webpack_require__(2473);
var TournamentPageTabs_module_default = /*#__PURE__*/__webpack_require__.n(TournamentPageTabs_module);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(9830);
// EXTERNAL MODULE: ./utils/tournaments.ts
var tournaments = __webpack_require__(3722);
// EXTERNAL MODULE: ./utils/time.ts
var time = __webpack_require__(8398);
// EXTERNAL MODULE: ./components/Cta/Cta.tsx
var Cta = __webpack_require__(3499);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/TournamentPageTabs/Overview.tsx









var Overview = function(param) {
    var endDate = param.endDate, startDate = param.startDate, courseName = param.courseName, playersCount = param.playersCount, isFinalSeason1 = param.isFinalSeason1, tournamentName = param.tournamentName, tournamentSeason = param.tournamentSeason, isPGATournament = param.isPGATournament, configurationInfo = param.configurationInfo, signUpStartTime = param.signUpStartTime, signUpEndTime = param.signUpEndTime;
    var ref, ref1;
    var dispatch = (0,UIContext/* useUI */.l)().dispatch;
    var signupUri = !!configurationInfo.length && configurationInfo[0].paymentUrl;
    var isElevated = (0,tournaments/* isElevatedRound */.bN)(tournamentSeason, tournamentName);
    var isFinalSeason2 = tournamentSeason === 2 && ((ref = tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.toLowerCase()) === null || ref === void 0 ? void 0 : ref.includes("final"));
    var isFinalSeason3 = tournamentSeason === 3 && ((ref1 = tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("final"));
    var getEntryFee = function() {
        if (isPGATournament) {
            return constants/* ENTRY_FEE_PGA */.m6;
        }
        if (isFinalSeason1 || isFinalSeason2 || isFinalSeason3) {
            return 0;
        }
        return constants/* ENTRY_FEE_WITH_TAX */.ih;
    };
    var signupStart = dayjs_min_default()(signUpStartTime);
    var signupEnd = dayjs_min_default()(signUpEndTime);
    var currentDate = dayjs_min_default()();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TournamentPageTabs_module_default()).overviewWrapper,
        children: [
            isPGATournament && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).overviewItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemTitle,
                        children: "NOTE:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemValue,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "PGA OF AMERICA PROFESSIONALS ONLY —",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://tm-short.me/L3UeUIJ",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: (TournamentPageTabs_module_default()).signupLink,
                                    children: "SIGN UP HERE"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).overviewItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemTitle,
                        children: [
                            translationKeys/* date */.hT,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemValue,
                        children: [
                            (0,time/* utcTimeLocal */.V)(startDate, "MMM. D, H:mm z"),
                            " -",
                            " ",
                            (0,time/* utcTimeLocal */.V)(endDate, "MMM. D, H:mm z, YYYY")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).overviewItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemTitle,
                        children: [
                            translationKeys/* entry-fee */.JX,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemValue,
                        children: [
                            "$",
                            getEntryFee()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).overviewItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemTitle,
                        children: [
                            translationKeys/* course */.N7,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemValue,
                        children: courseName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).overviewItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemTitle,
                        children: [
                            translationKeys/* purse */.D7,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemValue,
                        children: [
                            "$",
                            isFinalSeason1 ? constants/* INITIAL_PURSE.toLocaleString */.DW.toLocaleString("en-US") : (0,tournaments/* getTotalPrize */.J$)(playersCount, isElevated, isFinalSeason2, isPGATournament, isFinalSeason3).toLocaleString("en-US")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).overviewItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemTitle,
                        children: [
                            translationKeys/* players */.Fm,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TournamentPageTabs_module_default()).overviewItemValue,
                        children: tournamentSeason === 1 ? playersCount : isFinalSeason2 ? 100 : "".concat(playersCount, " / 1000")
                    })
                ]
            }),
            signUpStartTime && signUpEndTime && currentDate.isAfter(signupStart) && currentDate.isBefore(signupEnd) && (0,tournaments/* isPossibleToJoin */.Oq)(playersCount) && signupUri && !isPGATournament && !isFinalSeason3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta/* default */.Z, {
                name: translationKeys/* join-tournament */.pW,
                className: (TournamentPageTabs_module_default()).overviewJoinButton,
                onClick: function() {
                    window.localStorage.setItem("next_signup_uri", signupUri);
                    dispatch({
                        type: "toggleJoinFlowInfoModal",
                        payload: {
                            isOpen: true,
                            title: tournamentName,
                            modalType: "signup"
                        }
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var TournamentPageTabs_Overview = (Overview);

// EXTERNAL MODULE: ./components/TournamentPageTabs/CourseAndSettings.tsx
var CourseAndSettings = __webpack_require__(2270);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/EastOutlined.js
var EastOutlined = __webpack_require__(8433);
// EXTERNAL MODULE: ./components/PrizeList/PrizeListSeason1.tsx + 1 modules
var PrizeListSeason1 = __webpack_require__(7795);
;// CONCATENATED MODULE: ./components/TournamentPageTabs/Purse.tsx









var Purse = function(param) {
    var playersCount = param.playersCount, tournamentName = param.tournamentName, isFinalSeason1 = param.isFinalSeason1, tournamentId = param.tournamentId, isPGATournament = param.isPGATournament, tournamentSeason = param.tournamentSeason;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)(""), inputVal = ref8[0], setInputVal = ref8[1];
    var isElevated = (0,tournaments/* isElevatedRound */.bN)(tournamentSeason, tournamentName);
    var isFinalSeason2 = tournamentSeason === 2 && ((ref = tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.toLowerCase()) === null || ref === void 0 ? void 0 : ref.includes("final"));
    var isFinalSeason3 = tournamentSeason === 3 && ((ref1 = tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("final"));
    var isRound456 = (0,tournaments/* isRoundNumber456 */.xH)(tournamentName);
    var tournamentRoundSeason1 = "round_".concat(constants/* TOURNAMENT_IDS_SEASON_1.indexOf */.Ty.indexOf(tournamentId) + 1);
    var handleInputChange = function(e) {
        var target = e.target;
        setInputVal(target.value);
    };
    var getPrizeList = function() {
        if (tournamentSeason == 1) {
            return PrizeListSeason1/* PRIZE_TABLE */.w[tournamentRoundSeason1];
        }
        if (tournamentSeason == 2) {
            return isFinalSeason2 ? constants/* PRIZES_FINAL_SEASON_2 */.IM : (0,tournaments/* prizeCalculator */.pj)(playersCount, tournamentSeason, isElevated, isRound456);
        }
        if (tournamentSeason == 3) {
            return isPGATournament ? (0,tournaments/* prizeCalculatorPGA */.ks)(playersCount) : isFinalSeason3 ? constants/* PRIZES_FINAL_SEASON_3 */.Lm : (0,tournaments/* prizeCalculatorSeason3 */.UV)(playersCount);
        }
    };
    var prizeList = getPrizeList();
    var aggregateCtpPrizes = function() {
        if (tournamentSeason === 1) {
            return constants/* AGGREGATE_CTP_LAST */.rk;
        }
        if (isRound456) {
            return constants/* AGGREGATE_CTP_4_5_6_ROUNDS */.$p;
        }
        if (isFinalSeason2) {
            return constants/* AGGREGATE_CTP_FINALE */.dk;
        }
        return constants/* AGGREGATE_CTP */.T5;
    };
    var birdieStreakPrizes = function() {
        if (tournamentSeason === 1) {
            return constants/* BIRDIE_STREAK_LAST */.yw;
        }
        if (isRound456) {
            return constants/* BIRDIE_STREAK_4_5_6_ROUNDS */.QG;
        }
        return constants/* BIRDIE_STREAK */.yf;
    };
    var longestDrivePrizes = function() {
        if (tournamentSeason === 1) {
            return constants/* LONGEST_DRIVE_LAST */.YN;
        }
        if (isRound456) {
            return constants/* LONGEST_DRIVE_4_5_6_ROUNDS */.aC;
        }
        return constants/* LONGEST_DRIVE */.pf;
    };
    if (isPGATournament) {
        var ref9, ref10, ref11, ref12, ref13, ref14;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (TournamentPageTabs_module_default()).pursePageContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).pursePageWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (TournamentPageTabs_module_default()).purseUlList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* purse */.D7
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "$",
                                            (constants/* INITIAL_PURSE_PGA */.X9 + constants/* ENTRY_FEE_PGA */.m6 * playersCount).toLocaleString("en-US")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* players */.Fm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: playersCount
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).purseInfoBlocks,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                        children: translationKeys/* calculate */.Kf
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateText,
                                        children: translationKeys/* rank */.dZ
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "text-black",
                                        type: "number",
                                        defaultValue: inputVal,
                                        onChange: handleInputChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                        children: [
                                            "$",
                                            ((ref9 = prizeList[parseInt(inputVal) - 1]) === null || ref9 === void 0 ? void 0 : ref9.toLocaleString("en-US")) || "0"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* stroke-play */.yE
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref10 = prizeList[0]) === null || ref10 === void 0 ? void 0 : ref10.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref11 = prizeList[1]) === null || ref11 === void 0 ? void 0 : ref11.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref12 = prizeList[2]) === null || ref12 === void 0 ? void 0 : ref12.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "4th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref13 = prizeList[3]) === null || ref13 === void 0 ? void 0 : ref13.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "5th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref14 = prizeList[4]) === null || ref14 === void 0 ? void 0 : ref14.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* ctp-all */.Kd
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_PGA.0 */.xj[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_PGA.1 */.xj[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_PGA.2 */.xj[2]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "4th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_PGA.3 */.xj[3]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "5th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_PGA.4 */.xj[4]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((TournamentPageTabs_module_default()).purseInfoBlock, " ").concat((TournamentPageTabs_module_default()).purseInfoBlockCentered),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/tournament/".concat(tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.replace(/:/g, "").replace(/ - /g, " ").split(" ").join("-").toLowerCase(), "/prize-list"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: (TournamentPageTabs_module_default()).purseLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: translationKeys/* prize-list */.cP
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EastOutlined/* default */.Z, {
                                                    fontSize: "large"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (!isPGATournament && tournamentSeason === 3) {
        var ref15, ref16, ref17, ref18, ref19, ref20;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (TournamentPageTabs_module_default()).pursePageContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).pursePageWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (TournamentPageTabs_module_default()).purseUlList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* purse */.D7
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "$",
                                            (isFinalSeason3 ? constants/* INITIAL_PURSE_SEASON_3_FINAL */.hm : constants/* INITIAL_PURSE */.DW + constants/* ENTRY_FEE */.Uh * playersCount).toLocaleString("en-US")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* players */.Fm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: playersCount
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).purseInfoBlocks,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                        children: translationKeys/* calculate */.Kf
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateText,
                                        children: translationKeys/* rank */.dZ
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "text-black",
                                        type: "number",
                                        defaultValue: inputVal,
                                        onChange: handleInputChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                        children: [
                                            "$",
                                            ((ref15 = prizeList[parseInt(inputVal) - 1]) === null || ref15 === void 0 ? void 0 : ref15.toLocaleString("en-US")) || " 0"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* stroke-play */.yE
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref16 = prizeList[0]) === null || ref16 === void 0 ? void 0 : ref16.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref17 = prizeList[1]) === null || ref17 === void 0 ? void 0 : ref17.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref18 = prizeList[2]) === null || ref18 === void 0 ? void 0 : ref18.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "4th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref19 = prizeList[3]) === null || ref19 === void 0 ? void 0 : ref19.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "5th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref20 = prizeList[4]) === null || ref20 === void 0 ? void 0 : ref20.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* ctp-all */.Kd
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_SEASON_3.0 */.AK[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_SEASON_3.1 */.AK[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* CTP_SEASON_3.2 */.AK[2]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* aggregate-ctp */.kN
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* AGGREGATE_CTP_SEASON_3.0 */.qu[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* AGGREGATE_CTP_SEASON_3.1 */.qu[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* AGGREGATE_CTP_SEASON_3.2 */.qu[2]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* longest-drive-men */.nt
                                    }),
                                    isFinalSeason3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3_FINAL.0 */.i5[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3_FINAL.1 */.i5[1]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3.0 */.X2[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3.1 */.X2[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3.2 */.X2[2]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* longest-drive-women */.ED
                                    }),
                                    isFinalSeason3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3_FINAL.0 */.i5[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3_FINAL.1 */.i5[1]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3.0 */.X2[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3.1 */.X2[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* LONGEST_DRIVE_SEASON_3.2 */.X2[2]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isFinalSeason3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* social-media */.LU
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_SEASON_3.0 */.T3[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_SEASON_3.1 */.T3[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_SEASON_3.2 */.T3[2]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((TournamentPageTabs_module_default()).purseInfoBlock, " ").concat((TournamentPageTabs_module_default()).purseInfoBlockCentered),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/tournament/".concat(tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.replace(/:/g, "").replace(/ - /g, " ").split(" ").join("-").toLowerCase(), "/prize-list"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: (TournamentPageTabs_module_default()).purseLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: translationKeys/* prize-list */.cP
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EastOutlined/* default */.Z, {
                                                    fontSize: "large"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (isFinalSeason1) {
        var ref21, ref22, ref23, ref24, ref25, ref26;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (TournamentPageTabs_module_default()).pursePageContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TournamentPageTabs_module_default()).pursePageWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (TournamentPageTabs_module_default()).purseUlList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* purse */.D7
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "$",
                                            constants/* INITIAL_PURSE.toLocaleString */.DW.toLocaleString("en-US")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* players */.Fm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: playersCount
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TournamentPageTabs_module_default()).purseInfoBlocks,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                        children: translationKeys/* calculate */.Kf
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateText,
                                        children: translationKeys/* rank */.dZ
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "text-black",
                                        type: "number",
                                        defaultValue: inputVal,
                                        onChange: handleInputChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                        children: [
                                            "$",
                                            ((ref21 = prizeList[parseInt(inputVal) - 1]) === null || ref21 === void 0 ? void 0 : ref21.toLocaleString("en-US")) || " 0"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* stroke-play */.yE
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref22 = prizeList[0]) === null || ref22 === void 0 ? void 0 : ref22.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref23 = prizeList[1]) === null || ref23 === void 0 ? void 0 : ref23.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref24 = prizeList[2]) === null || ref24 === void 0 ? void 0 : ref24.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "4th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref25 = prizeList[3]) === null || ref25 === void 0 ? void 0 : ref25.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "5th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref26 = prizeList[4]) === null || ref26 === void 0 ? void 0 : ref26.toLocaleString("en-US")) || 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* aggregate-ctp */.kN
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* AGGREGATE_CTP_FINALE.0 */.dk[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* AGGREGATE_CTP_FINALE.1 */.dk[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* AGGREGATE_CTP_FINALE.2 */.dk[2]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TournamentPageTabs_module_default()).purseInfoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: translationKeys/* social-media */.LU
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_FINALE.0 */.A4[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_FINALE.1 */.A4[1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_FINALE.2 */.A4[2]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "4th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_FINALE.3 */.A4[3]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "5th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_FINALE.4 */.A4[4]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((TournamentPageTabs_module_default()).purseInfoBlock, " ").concat((TournamentPageTabs_module_default()).purseInfoBlockCentered),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/tournament/".concat(tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.replace(/:/g, "").replace(/ - /g, " ").split(" ").join("-").toLowerCase(), "/prize-list"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: (TournamentPageTabs_module_default()).purseLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: translationKeys/* prize-list */.cP
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EastOutlined/* default */.Z, {
                                                    fontSize: "large"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TournamentPageTabs_module_default()).pursePageContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TournamentPageTabs_module_default()).pursePageWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: (TournamentPageTabs_module_default()).purseUlList,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* purse */.D7
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "$",
                                        (0,tournaments/* getTotalPrize */.J$)(playersCount, isElevated, isFinalSeason2).toLocaleString("en-US")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* players */.Fm
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: isFinalSeason2 ? 100 : playersCount
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TournamentPageTabs_module_default()).purseInfoBlocks,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                    children: translationKeys/* calculate */.Kf
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (TournamentPageTabs_module_default()).purseCalculateText,
                                    children: translationKeys/* rank */.dZ
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "text-black",
                                    type: "number",
                                    defaultValue: inputVal,
                                    onChange: handleInputChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TournamentPageTabs_module_default()).purseCalculateTitle,
                                    children: [
                                        "$",
                                        ((ref2 = prizeList[parseInt(inputVal) - 1]) === null || ref2 === void 0 ? void 0 : ref2.toLocaleString("en-US")) || "0"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* stroke-play */.yE
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "1st"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ((ref3 = prizeList[0]) === null || ref3 === void 0 ? void 0 : ref3.toLocaleString("en-US")) || 0
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "2nd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ((ref4 = prizeList[1]) === null || ref4 === void 0 ? void 0 : ref4.toLocaleString("en-US")) || 0
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "3rd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ((ref5 = prizeList[2]) === null || ref5 === void 0 ? void 0 : ref5.toLocaleString("en-US")) || 0
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "4th"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ((ref6 = prizeList[3]) === null || ref6 === void 0 ? void 0 : ref6.toLocaleString("en-US")) || 0
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "5th"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ((ref7 = prizeList[4]) === null || ref7 === void 0 ? void 0 : ref7.toLocaleString("en-US")) || 0
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* aggregate-ctp */.kN
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "1st"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: aggregateCtpPrizes()[0]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "2nd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: aggregateCtpPrizes()[1]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "3rd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: aggregateCtpPrizes()[2]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isFinalSeason2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* birdie-streak */.DS
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "1st"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: birdieStreakPrizes()[0]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "2nd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: birdieStreakPrizes()[1]
                                                })
                                            ]
                                        }),
                                        !isRound456 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "3rd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: birdieStreakPrizes()[2]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isFinalSeason2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* longest-drive-men */.nt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "1st"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: longestDrivePrizes()[0]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "2nd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: longestDrivePrizes()[1]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "3rd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: longestDrivePrizes()[2]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isFinalSeason2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* longest-drive-women */.ED
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "1st"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: longestDrivePrizes()[0]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "2nd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: longestDrivePrizes()[1]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "3rd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: longestDrivePrizes()[2]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isFinalSeason2 && !isRound456 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* most-girs */.WK
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "1st"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: tournamentSeason === 1 ? constants/* MOST_GIRS_LAST.0 */.ai[0] : constants/* MOST_GIRS.0 */.kf[0]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "2nd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: tournamentSeason === 1 ? constants/* MOST_GIRS_LAST.1 */.ai[1] : constants/* MOST_GIRS.1 */.kf[1]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "3rd"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: tournamentSeason === 1 ? constants/* MOST_GIRS_LAST.2 */.ai[2] : constants/* MOST_GIRS.2 */.kf[2]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isFinalSeason2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TournamentPageTabs_module_default()).purseInfoBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationKeys/* social-media */.LU
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (TournamentPageTabs_module_default()).purseUlBlockList,
                                    children: tournamentSeason === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "1st"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_LAST */.zE
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2nd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_LAST */.zE
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "3rd"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_LAST */.zE
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "4th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_LAST */.zE
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "5th"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA_LAST */.zE
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : isFinalSeason2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "2x"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: constants/* SOCIAL_MEDIA.1 */.CL[1]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2x"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA.0 */.CL[0]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "2x"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: constants/* SOCIAL_MEDIA.1 */.CL[1]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((TournamentPageTabs_module_default()).purseInfoBlock, " ").concat((TournamentPageTabs_module_default()).purseInfoBlockCentered),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/tournament/".concat(tournamentName === null || tournamentName === void 0 ? void 0 : tournamentName.replace(/:/g, "").replace(/ - /g, " ").split(" ").join("-").toLowerCase(), "/prize-list"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: (TournamentPageTabs_module_default()).purseLink,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: translationKeys/* prize-list */.cP
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EastOutlined/* default */.Z, {
                                                fontSize: "large"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TournamentPageTabs_Purse = (Purse);

// EXTERNAL MODULE: ./components/LeaderboardWrapper/LeaderboardWrapper.tsx + 18 modules
var LeaderboardWrapper = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/GridWrapper/GridWrapper.tsx
var GridWrapper = __webpack_require__(7617);
// EXTERNAL MODULE: ./components/GridElement/GridElement.tsx + 3 modules
var GridElement = __webpack_require__(5721);
// EXTERNAL MODULE: ./components/BackgroundGraphic/BackgroundGraphic.tsx
var BackgroundGraphic = __webpack_require__(373);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./components/GridElement/index.ts
var components_GridElement = __webpack_require__(5299);
// EXTERNAL MODULE: ./components/GridWrapper/index.ts
var components_GridWrapper = __webpack_require__(2409);
// EXTERNAL MODULE: ./components/PrizeList/PrizeList.module.css
var PrizeList_module = __webpack_require__(8729);
var PrizeList_module_default = /*#__PURE__*/__webpack_require__.n(PrizeList_module);
;// CONCATENATED MODULE: ./components/PrizeList/PrizeList.tsx








var PrizeList = function(param) {
    var tournament = param.tournament, isPGATournament = param.isPGATournament;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var playersCount = (tournament === null || tournament === void 0 ? void 0 : (ref = tournament.participants) === null || ref === void 0 ? void 0 : ref.allInvitationsCount) - (tournament === null || tournament === void 0 ? void 0 : (ref1 = tournament.participants) === null || ref1 === void 0 ? void 0 : ref1.declinedCount) - (tournament === null || tournament === void 0 ? void 0 : (ref2 = tournament.participants) === null || ref2 === void 0 ? void 0 : ref2.withdrawnCount);
    var isElevated = (0,tournaments/* isElevatedRound */.bN)(tournament.season, tournament.name);
    var isFinalSeason2 = tournament.season === 2 && ((ref4 = (ref3 = tournament.name) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === null || ref4 === void 0 ? void 0 : ref4.includes("final"));
    var isFinalSeason3 = tournament.season === 3 && ((ref6 = (ref5 = tournament.name) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) === null || ref6 === void 0 ? void 0 : ref6.includes("final"));
    var isRound456 = (0,tournaments/* isRoundNumber456 */.xH)(tournament.name);
    var getPrizeTable = function() {
        if (tournament.season === 3) {
            return isPGATournament ? (0,tournaments/* prizeCalculatorPGA */.ks)(playersCount) : isFinalSeason3 ? constants/* PRIZES_FINAL_SEASON_3 */.Lm : (0,tournaments/* prizeCalculatorSeason3 */.UV)(playersCount);
        }
        if (isFinalSeason2) {
            return (0,_to_consumable_array/* default */.Z)(constants/* PRIZES_FINAL_SEASON_2 */.IM).concat((0,_to_consumable_array/* default */.Z)(Array.from(Array(90)).map(function() {
                return 0;
            })));
        }
        return (0,tournaments/* prizeCalculator */.pj)(playersCount, tournament.season, isElevated, isRound456);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_GridWrapper/* default */.Z, {
        padding_top: GridWrapper/* Spacing.x_large */.K.x_large,
        padding_bottom: GridWrapper/* Spacing.x_large */.K.x_large,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_GridElement/* default */.Z, {
                gridLayout: [
                    [
                        0,
                        1,
                        4,
                        2
                    ],
                    [
                        961,
                        7,
                        4,
                        2
                    ],
                    [
                        1401,
                        14,
                        6,
                        2
                    ], 
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GridElement/* default */.Z, {
                        gridLayout: [
                            [
                                0,
                                1,
                                4,
                                1
                            ],
                            [
                                961,
                                6,
                                6,
                                1
                            ],
                            [
                                1401,
                                12,
                                10,
                                1
                            ], 
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (PrizeList_module_default()).prizeListTitle,
                            children: "Stroke play"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PrizeList_module_default()).prizeListSubTitleWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: (PrizeList_module_default()).prizeListSubTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (PrizeList_module_default()).prizeListSubTitleLabel,
                                        children: "Purse"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (PrizeList_module_default()).prizeListSubTitleValue,
                                        children: [
                                            "$",
                                            (0,tournaments/* getTotalPrize */.J$)(playersCount, isElevated, isFinalSeason2, isPGATournament, isFinalSeason3).toLocaleString("en-US")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: (PrizeList_module_default()).prizeListSubTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (PrizeList_module_default()).prizeListSubTitleLabel,
                                        children: "Players"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (PrizeList_module_default()).prizeListSubTitleValue,
                                        children: isFinalSeason2 ? 100 : playersCount
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GridElement/* default */.Z, {
                gridLayout: [
                    [
                        0,
                        1,
                        4,
                        3
                    ],
                    [
                        961,
                        5,
                        8,
                        3
                    ],
                    [
                        1401,
                        9,
                        16,
                        3
                    ], 
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    className: (PrizeList_module_default()).prizeList,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (PrizeList_module_default()).prizeListItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Position"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Prize money"
                                })
                            ]
                        }),
                        (ref7 = getPrizeTable()) === null || ref7 === void 0 ? void 0 : ref7.map(function(item, index) {
                            return item > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (PrizeList_module_default()).prizeListItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "$",
                                            item.toLocaleString("en-US")
                                        ]
                                    })
                                ]
                            }, index);
                        }),
                        ((ref8 = getPrizeTable()) === null || ref8 === void 0 ? void 0 : ref8.indexOf(0)) !== -1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (PrizeList_module_default()).prizeListItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        getPrizeTable().indexOf(0) + 1,
                                        "...",
                                        (ref9 = getPrizeTable()) === null || ref9 === void 0 ? void 0 : ref9.length
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "$0"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var PrizeList_PrizeList = (PrizeList);

// EXTERNAL MODULE: ./components/JoinFlowInfoModal/JoinFlowInfoModal.tsx
var JoinFlowInfoModal = __webpack_require__(7425);
// EXTERNAL MODULE: ./hooks/useTmSignOut.ts
var useTmSignOut = __webpack_require__(5473);
// EXTERNAL MODULE: ./components/LeaderboardModal/LeaderboardModal.tsx
var LeaderboardModal = __webpack_require__(1416);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@storyblok/react/dist/storyblok-react.mjs
var storyblok_react = __webpack_require__(9036);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(8357);
// EXTERNAL MODULE: ./node_modules/react-country-flag/dist/react-country-flag.esm.js
var react_country_flag_esm = __webpack_require__(9318);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 192 modules
var motion = __webpack_require__(4538);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(7572);
// EXTERNAL MODULE: ./components/OOMLeaderboard/OOMLeaderboard.module.css
var OOMLeaderboard_module = __webpack_require__(1350);
var OOMLeaderboard_module_default = /*#__PURE__*/__webpack_require__.n(OOMLeaderboard_module);
// EXTERNAL MODULE: ./components/Leaderboard/animations.ts
var animations = __webpack_require__(7067);
// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(2761);
;// CONCATENATED MODULE: ./components/TournamentPageTabs/Earnings.tsx













var Earnings = function(param) {
    var csvFile = param.csvFile;
    var windowSize = (0,useWindowSize/* useWindowSize */.i)().windowSize;
    var ref = (0,react.useState)([]), activeRows = ref[0], setActiveRows = ref[1];
    var ref1 = (0,react.useState)(""), searchText = ref1[0], setSearchText = ref1[1];
    var handleRowClick = function(id) {
        setActiveRows(function(prevRows) {
            return prevRows.includes(id) ? prevRows.filter(function(i) {
                return i !== id;
            }) : (0,_to_consumable_array/* default */.Z)(prevRows).concat([
                id
            ]);
        });
    };
    var debouncedSearchText = (0,useDebounce/* useDebounce */.N)(searchText, 300);
    var filteredData = (0,react.useMemo)(function() {
        if (!debouncedSearchText) return (csvFile === null || csvFile === void 0 ? void 0 : csvFile.slice(1)) || []; // Return all rows if no search text
        return (csvFile === null || csvFile === void 0 ? void 0 : csvFile.slice(1) // Exclude the header row
        .filter(function(row) {
            return row.some(function(cell) {
                return cell === null || cell === void 0 ? void 0 : cell.toString().toLowerCase().includes(debouncedSearchText.toLowerCase());
            });
        })) || [];
    }, [
        debouncedSearchText
    ]);
    var handleSearchInputChange = function(event) {
        var searchText = event.target.value;
        setSearchText(searchText);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridWrapper/* default */.Z, {
        className: (OOMLeaderboard_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridElement/* default */.Z, {
                gridLayout: [
                    [
                        961,
                        2,
                        14
                    ],
                    [
                        1401,
                        4,
                        26
                    ], 
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridWrapper/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridElement/* default */.Z, {
                        gridLayout: [
                            [
                                961,
                                1,
                                16,
                                2
                            ],
                            [
                                1401,
                                1,
                                32
                            ], 
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col md:flex-row justify-center lg:justify-end items-center gap-[10px] mx-0 mb-[10px] md:mt-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center w-full max-w-[330px] lg:max-w-[280px] min-h-[45px] text-2xl bg-[#343434] rounded-[10px] cursor-pointer px-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "search",
                                        placeholder: "Search for player",
                                        value: searchText,
                                        onChange: handleSearchInputChange,
                                        className: "custom-search-input w-full border-none bg-transparent p-0 m-0 text-2xl focus-visible:outline-none"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                        fontSize: "large",
                                        className: "text-white cursor-pointer"
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridElement/* default */.Z, {
                gridLayout: [
                    [
                        961,
                        2,
                        14,
                        2
                    ],
                    [
                        1401,
                        4,
                        26,
                        2
                    ], 
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-32 overflow-y-auto scroll-smooth",
                    children: csvFile && (csvFile === null || csvFile === void 0 ? void 0 : csvFile.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        role: "table",
                        className: (OOMLeaderboard_module_default()).leaderboardTable,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "thead",
                                className: (OOMLeaderboard_module_default()).tableHeader,
                                children: csvFile[0].slice(0, 4).map(function(i, n) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "th",
                                        className: (OOMLeaderboard_module_default()).tableHeaderCell,
                                        children: n === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (OOMLeaderboard_module_default()).thCellLabel,
                                            children: i
                                        }) : i
                                    }, "".concat(i, "-").concat(n));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "tbody",
                                className: (OOMLeaderboard_module_default()).tableBody,
                                children: filteredData.map(function(i, index) {
                                    var ref;
                                    var rowID = i[0] + ((ref = i[2]) === null || ref === void 0 ? void 0 : ref.replace(/\s/g, "")) + i[3] || i[0] + index;
                                    var filteredDataFromCSV = csvFile[0].filter(function(str) {
                                        return !!(str === null || str === void 0 ? void 0 : str.length);
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* InView */.df, {
                                        threshold: 0.5,
                                        triggerOnce: true,
                                        children: function(param) {
                                            var inView = param.inView, ref = param.ref;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: ref,
                                                role: "tr",
                                                className: "".concat((OOMLeaderboard_module_default()).tableRowGroup).concat(activeRows.includes(rowID) ? " " + (OOMLeaderboard_module_default()).tableRowGroupActive : ""),
                                                children: inView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            role: "tr",
                                                            className: (OOMLeaderboard_module_default()).tableRow,
                                                            onClick: function() {
                                                                return handleRowClick(rowID);
                                                            },
                                                            children: i.slice(0, 4).map(function(d, n) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    role: "td",
                                                                    className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                    children: n === 1 ? d ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_country_flag_esm/* default */.Z, {
                                                                        countryCode: d,
                                                                        style: {
                                                                            fontSize: "1.5em"
                                                                        },
                                                                        svg: true
                                                                    }) : "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (OOMLeaderboard_module_default()).data,
                                                                        children: d
                                                                    })
                                                                }, "".concat(index, "-").concat(n, "-").concat(d));
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                                            children: activeRows.includes(rowID) && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                                                role: "rowgroup",
                                                                className: "".concat((OOMLeaderboard_module_default()).tableRowGroupInner).concat(filteredDataFromCSV.length > 10 && windowSize.width < 961 ? " " + (OOMLeaderboard_module_default()).tableRowGroupInnerLarge : ""),
                                                                variants: animations/* groupInnerVariants */.p,
                                                                initial: "initial",
                                                                animate: activeRows.includes(rowID) ? "open" : "initial",
                                                                exit: "initial",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (OOMLeaderboard_module_default()).tableRowGroupInnerContent,
                                                                    children: filteredDataFromCSV.length <= 10 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "thead",
                                                                                className: (OOMLeaderboard_module_default()).tableHeader,
                                                                                children: filteredDataFromCSV.slice(4, filteredDataFromCSV.length).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "table-header-".concat(d, "-").concat(n));
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "tr",
                                                                                className: (OOMLeaderboard_module_default()).tableRow,
                                                                                children: i.slice(4, filteredDataFromCSV.length).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "tr-".concat(n, "-").concat(d));
                                                                                })
                                                                            })
                                                                        ]
                                                                    }) : windowSize.width > 960 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "thead",
                                                                                className: (OOMLeaderboard_module_default()).tableHeader,
                                                                                children: filteredDataFromCSV.slice(4, csvFile.length).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "table-header-".concat(n, "-").concat(d));
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "tr",
                                                                                className: (OOMLeaderboard_module_default()).tableRow,
                                                                                children: i.slice(4, filteredDataFromCSV.length).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "table-row-".concat(n, "-").concat(d));
                                                                                })
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "thead",
                                                                                className: (OOMLeaderboard_module_default()).tableHeader,
                                                                                children: filteredDataFromCSV.slice(4, 7).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "thead-td-".concat(n, "-").concat(d));
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "tr",
                                                                                className: (OOMLeaderboard_module_default()).tableRow,
                                                                                children: i.slice(4, 7).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "tr-td-".concat(n, "-").concat(d));
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "thead",
                                                                                className: (OOMLeaderboard_module_default()).tableHeader,
                                                                                children: filteredDataFromCSV.slice(7, 11).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "thead-row-cell-".concat(n, "-").concat(d));
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                role: "tr",
                                                                                className: (OOMLeaderboard_module_default()).tableRow,
                                                                                children: i.slice(7, 11).map(function(d, n) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        role: "td",
                                                                                        className: (OOMLeaderboard_module_default()).tableRowCell,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (OOMLeaderboard_module_default()).data,
                                                                                            children: d
                                                                                        })
                                                                                    }, "tr-cell-".concat(n, "-").concat(d));
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (OOMLeaderboard_module_default()).tableRow
                                                })
                                            });
                                        }
                                    }, "".concat(rowID, "-").concat(index));
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TournamentPageTabs_Earnings = (Earnings);

// EXTERNAL MODULE: ./components/YouTubePlaylist/index.ts
var YouTubePlaylist = __webpack_require__(7693);
;// CONCATENATED MODULE: ./pages/tournament/[...slug].tsx

























var TournamentPageHead = function(param) {
    var metaTitle = param.metaTitle, isScoreCard = param.isScoreCard, isProd = param.isProd;
    var title = isScoreCard ? "View My Scorecard - NEXT Golf Tour" : metaTitle;
    var description = isScoreCard ? "Dive into the action with video and detailed hole-by-hole scores from my round in the NEXT Golf Tour." : "The NEXT Golf Tour: Professional golf with real stakes played in a Trackman golf simulator. Experience the skill, intensity, and thrill of tournament play.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            !isProd && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width, maximum-scale=1.0, user-scalable=0"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "/images/next_tournament_s3.jpg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:image",
                content: "/images/next_tournament_s3.jpg"
            })
        ]
    });
};
var __N_SSG = true;
function TournamentOverviewPage(param) {
    var story = param.story, tournament = param.tournament, courseSettings = param.courseSettings, pageSlug = param.pageSlug, isProd = param.isProd, tabs = param.tabs, nationalitiesOptions = param.nationalitiesOptions, csvFiles = param.csvFiles, videos = param.videos, videosTemplate = param.videosTemplate, nextPageToken = param.nextPageToken, playlistId = param.playlistId;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    story = (0,storyblok_react/* useStoryblokState */.f0)(story);
    var ref14 = (0,UIContext/* useUI */.l)(), uiState = ref14.state;
    var ref15 = (0,next_auth_react.useSession)(), session = ref15.data;
    var ref16 = (0,react.useState)(""), verifyEmailFlow = ref16[0], setVerifyEmailFlow = ref16[1];
    var ref17 = (0,router.useRouter)(), asPath = ref17.asPath, playerid = ref17.query.playerid;
    (0,react.useEffect)(function() {
        if (verifyEmailFlow !== window.localStorage.getItem("verify_email_flow")) {
            setVerifyEmailFlow(window.localStorage.getItem("verify_email_flow"));
        }
    }, [
        uiState
    ]);
    var ref18 = tournament !== null && tournament !== void 0 ? tournament : {}, name = ref18.name, season = ref18.season, rounds = ref18.rounds, startDate = ref18.startDate, endDate = ref18.endDate, sponsors = ref18.sponsors, participants = ref18.participants, tournamentId = ref18.id;
    var playersCount = (participants === null || participants === void 0 ? void 0 : participants.allInvitationsCount) - (participants === null || participants === void 0 ? void 0 : participants.declinedCount) - (participants === null || participants === void 0 ? void 0 : participants.withdrawnCount);
    var isPGATournament = tournamentId === constants/* PGA_TOURNAMENT_ID */.fD;
    var isFinalSeason3 = season === 3 && ((ref = name === null || name === void 0 ? void 0 : name.toLowerCase()) === null || ref === void 0 ? void 0 : ref.includes("final"));
    (0,useTmSignOut/* useTmSignOut */.y)();
    (0,react.useEffect)(function() {
        if (typeof document !== "undefined") {
            if (playerid && typeof playerid === "string" && pageSlug === "leaderboard") {
                document.body.style.overflow = "hidden";
                document.body.style.position = "fixed";
                document.body.style.width = "100%";
            } else {
                document.body.style.overflow = "auto";
                document.body.style.position = "static";
                document.body.style.width = "unset";
            }
        }
    }, [
        playerid,
        pageSlug
    ]);
    if (pageSlug === "prize-list") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TournamentPageHead, {
                    metaTitle: name,
                    isProd: isProd
                }),
                season === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizeListSeason1/* default */.Z, {
                    defaultSpacing: "x_large",
                    tournamentId: tournamentId
                }),
                (season === 2 || season === 3) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizeList_PrizeList, {
                    tournament: tournament,
                    isPGATournament: isPGATournament
                })
            ]
        });
    }
    var csvFileByTournament = csvFiles.find(//TODO: rework after season 3 has all csv
    function(file) {
        if (isPGATournament) {
            return file.name.includes("S3") && file.name.includes("PGA");
        }
        if (tournament.name.trim().toLowerCase().includes("round 1")) {
            return file.name.includes("S3") && file.name.includes("R1");
        }
        if (tournament.name.trim().toLowerCase().includes("round 2")) {
            return file.name.includes("S3") && file.name.includes("R2");
        }
        if (tournament.name.trim().toLowerCase().includes("round 3")) {
            return file.name.includes("S3") && file.name.includes("R3");
        }
        if (tournament.name.trim().toLowerCase().includes("final")) {
            return file.name.includes("S3") && file.name.includes("R4");
        }
        return;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TournamentPageHead, {
                metaTitle: name,
                isScoreCard: asPath.includes("playerid"),
                isProd: isProd
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinFlowInfoModal/* default */.Z, {
                isOpen: uiState.joinFlowInfoModal.isOpen && ((session === null || session === void 0 ? void 0 : session.accessToken) && !uiState.isEmailVerified && verifyEmailFlow === "true" && uiState.joinFlowInfoModal.modalType === "email" || uiState.joinFlowInfoModal.modalType === "signup"),
                tmToken: session === null || session === void 0 ? void 0 : session.accessToken,
                idTokenHint: session === null || session === void 0 ? void 0 : session.idToken
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TournamentPageTabs/* default */.Z, {
                tournamentId: tournament === null || tournament === void 0 ? void 0 : tournament.id,
                signUpStartTime: tournament.signUpStartTime,
                signUpEndTime: tournament.signUpEndTime,
                playersCount: playersCount,
                signupUri: !!(tournament === null || tournament === void 0 ? void 0 : (ref1 = tournament.locationsConfiguration) === null || ref1 === void 0 ? void 0 : ref1.length) && (tournament === null || tournament === void 0 ? void 0 : tournament.locationsConfiguration[0].paymentUrl),
                logo: sponsors === null || sponsors === void 0 ? void 0 : (ref2 = sponsors[0]) === null || ref2 === void 0 ? void 0 : ref2.logoUri,
                name: name,
                tabs: tabs,
                isPGATournament: isPGATournament,
                isEarnings: !!csvFileByTournament,
                isFinalSeason3: isFinalSeason3
            }),
            pageSlug !== "leaderboard" && /*#__PURE__*/ (0,jsx_runtime.jsx)(GridWrapper/* default */.Z, {
                style: {
                    marginBottom: "50px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridElement/* default */.Z, {
                    gridLayout: [
                        [
                            1401,
                            4,
                            26
                        ]
                    ],
                    children: [
                        pageSlug === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TournamentPageTabs_Overview, {
                            configurationInfo: tournament === null || tournament === void 0 ? void 0 : tournament.locationsConfiguration,
                            startDate: startDate,
                            endDate: endDate,
                            courseName: rounds === null || rounds === void 0 ? void 0 : (ref3 = rounds[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.course) === null || ref4 === void 0 ? void 0 : ref4.displayName,
                            playersCount: playersCount,
                            isFinalSeason1: (0,tournaments/* isFinalSeason1 */.b7)(tournamentId),
                            tournamentName: name,
                            tournamentSeason: season,
                            isPGATournament: isPGATournament,
                            signUpStartTime: tournament.signUpStartTime,
                            signUpEndTime: tournament.signUpEndTime
                        }),
                        pageSlug === "course-and-settings" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseAndSettings/* default */.Z, {
                            settings: courseSettings === null || courseSettings === void 0 ? void 0 : (ref5 = courseSettings.round) === null || ref5 === void 0 ? void 0 : ref5.settings,
                            course: courseSettings === null || courseSettings === void 0 ? void 0 : (ref6 = courseSettings.round) === null || ref6 === void 0 ? void 0 : ref6.course,
                            selectedHoles: courseSettings === null || courseSettings === void 0 ? void 0 : (ref7 = courseSettings.rounds) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.embeddedGame) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.longestDrive) === null || ref10 === void 0 ? void 0 : ref10.holes,
                            tournamentId: tournamentId,
                            tournamentName: name,
                            tournamentSeason: season
                        }),
                        pageSlug === "purse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TournamentPageTabs_Purse, {
                            playersCount: playersCount,
                            tournamentName: name,
                            isFinalSeason1: (0,tournaments/* isFinalSeason1 */.b7)(tournamentId),
                            tournamentId: tournamentId,
                            isPGATournament: isPGATournament,
                            tournamentSeason: season
                        }),
                        pageSlug === "earnings" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TournamentPageTabs_Earnings, {
                            csvFile: csvFileByTournament === null || csvFileByTournament === void 0 ? void 0 : csvFileByTournament.data
                        })
                    ]
                })
            }),
            pageSlug === "leaderboard" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            marginBottom: "50px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundGraphic/* default */.Z, {}),
                            videos && videos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTubePlaylist/* default */.Z, {
                                videos: videos,
                                videosTemplate: videosTemplate,
                                nextPageToken: nextPageToken,
                                playlistId: playlistId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardWrapper/* default */.Z, {
                                tournamentSeason: season,
                                isNowPlaying: (0,tournaments/* isNowPlayingTournament */.ev)(startDate, endDate),
                                startDate: startDate,
                                tournamentId: tournamentId,
                                tournamentName: name,
                                // isFinale={isFinalRound(season, name)}
                                nationalitiesOptions: nationalitiesOptions,
                                ctpSelectOptions: (ref11 = tournament === null || tournament === void 0 ? void 0 : tournament.rounds[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.embeddedGame) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.closestToPin) === null || ref13 === void 0 ? void 0 : ref13.holes,
                                isPGATournament: isPGATournament
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: playerid && typeof playerid === "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardModal/* default */.Z, {
                            tournamentId: tournamentId,
                            playerId: playerid
                        })
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [678,885,758,774,888,179], function() { return __webpack_exec__(1047); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);